import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './DeleteAccount.css';

const WEB3FORMS_ACCESS_KEY = '89ed5637-c4a0-49de-ac25-94667d3d1b88';

function DeleteAccount() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState(null); // { type: 'success' | 'error', message: string }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setToast(null);

    try {
      const formData = new FormData();
      formData.append('access_key', WEB3FORMS_ACCESS_KEY);
      formData.append('name', name);
      formData.append('email', email);
      formData.append('message', message);

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setToast({ type: 'success', message: 'Request submitted successfully. We\'ll process your account deletion and get back to you.' });
        setName('');
        setEmail('');
        setMessage('');
      } else {
        setToast({ type: 'error', message: data.message || 'Something went wrong. Please try again.' });
      }
    } catch (err) {
      setToast({ type: 'error', message: 'Failed to send. Please check your connection and try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => setToast(null), 5000);
    return () => clearTimeout(id);
  }, [toast]);

  return (
    <div className="delete-account-page">
      {toast && (
        <div className={`toast toast-${toast.type}`}>
          {toast.message}
        </div>
      )}
      <div className="delete-account-container">
        <h1 className="page-title">Delete Account</h1>
        <p className="page-subtitle">
          Submit a request to delete your Apna Soundbox account and associated data.
        </p>

        <div className="delete-account-form-container">
          <form onSubmit={handleSubmit} className="delete-account-form">
            <input type="hidden" name="access_key" value={WEB3FORMS_ACCESS_KEY} />
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Your account email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Please provide your account details (mobile number), reason for deletion, and any other information you think is relevant..."
                className="form-input form-textarea"
                required
                rows="4"
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="delete-button" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Request Deletion'}
              </button>
              <Link to="/" className="cancel-button">
                Cancel
              </Link>
            </div>

            <div className="form-notice">
              <p>
                Your request will be sent to <strong>support@apnasoundbox.com</strong> with the subject "Request for account deletion".
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccount;
